import React, { Component } from 'react'
import './index.css'
import {FaUser,FaUserEdit} from 'react-icons/fa'
import PubSub from 'pubsub-js'
import { Link } from 'react-router-dom'
import { FaShoppingCart } from "react-icons/fa";
import Cookies from 'universal-cookie'
import withRouter from '../../../withRouter'
class User extends Component {
    constructor(props){
        super(props)
        this.cookies = new Cookies()
        this.state ={
            cartItemsNumber:0,
            cartItems:[],
            isLogin:this.cookies.get('login')
        }
    }
    
    loginClick = ()=>{
        if(this.state.isLogin){
            this.props.navigate('/acer/signin',{state:{from:this.props.location.pathname}})
        }else{
            PubSub.publish('loginClick',true)
        }
    }
    componentDidUpdate(){
        if(this.props.cartItemsNumber!== this.state.cartItemsNumber){
            this.setState({cartItems:[...this.props.cartItems],cartItemsNumber:this.props.cartItemsNumber})
        }
    }
    componentDidMount(){
        // console.log(this.props)
        if(this.props.cartItems?.length > 0 || this.props.cartItemsNumber > 0){
            this.setState({cartItems:[...this.props.cartItems],cartItemsNumber:this.props.cartItemsNumber})
        }
        this.token = PubSub.subscribe('isLogin',(_,data)=>{
            this.setState({isLogin:data})
        })
        // this.setState({isLogin:document.cookie.includes('login=true')})
    }
    componentWillUnmount(){
        PubSub.unsubscribe(this.token)
    }
    render() {
        return (
            <div className="header-user">
                {/* <Link to='/acer/signin'><button><FaUser color='black' fontSize="25px" style={{margin:'0px'}}/> <p>{this.state.isLogin?'Account':'Sign in'}</p></button></Link> */}
                <button onClick={(e)=>{this.loginClick()}} ><FaUser color='black' fontSize="25px" style={{margin:'0px'}}/> <p>{this.state.isLogin?'Account':'Sign in'}</p></button>
                <Link to='/acer/cart' state={{cartItems:this.props.cartItems}}><button><FaShoppingCart color='black' fontSize="30px" style={{margin:'0px'}}/> <p>Cart{this.state.cartItemsNumber?`(${this.state.cartItemsNumber})`:""}</p></button></Link>
            </div>
        )
    }
}

export default withRouter(User)